var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRuleStoppedVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66005 6.72071C4.46747 8.15133 3.75 9.99188 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C14.0081 20.25 15.8487 19.5325 17.2793 18.3399L15.5197 16.5803C15.2268 16.2874 15.2268 15.8126 15.5197 15.5197C15.8126 15.2268 16.2874 15.2268 16.5803 15.5197L18.3399 17.2793C19.5325 15.8487 20.25 14.0081 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C9.99188 3.75 8.15133 4.46747 6.72071 5.66005L7.53033 6.46967C7.82322 6.76256 7.82322 7.23744 7.53033 7.53033C7.23744 7.82322 6.76256 7.82322 6.46967 7.53033L5.66005 6.72071ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3847 2.25 21.75 6.61522 21.75 12C21.75 17.3847 17.3847 21.75 12 21.75C6.61522 21.75 2.25 17.3847 2.25 12ZM9.25 8C9.25 7.58579 9.58579 7.25 10 7.25H13.4211C15.1982 7.25 16.75 8.58732 16.75 10.3684C16.75 12.1495 15.1982 13.4868 13.4211 13.4868H10.75V17C10.75 17.4142 10.4142 17.75 10 17.75C9.58579 17.75 9.25 17.4142 9.25 17V8ZM10.75 11.9868H13.4211C14.4925 11.9868 15.25 11.2034 15.25 10.3684C15.25 9.53344 14.4925 8.75 13.4211 8.75H10.75V11.9868Z",
    fill: "#747E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRuleStoppedVehicle);
export default __webpack_public_path__ + "static/media/icon-rule-stopped-vehicle.8a7b250b2b7764b296fe9fe389aec126.svg";
export { ForwardRef as ReactComponent };